const docTypeFields = {
    "Account": [
        "disabled",
        "account_name",
        "account_number",
        "is_group",
        "company",
        "root_type",
        "report_type",
        "account_currency",
        "parent_account",
        "account_type",
        "tax_rate"
    ],
    "Company": [
        "id"
    ],
    "ItemGroup": [
        "item_group_name",
        "parent_item_group",
        "is_group",
        "image",
        "description",
        "showpos"
    ],
    "PriceList": [
        "enabled",
        "price_list_name",
        "currency",
        "buying",
        "selling",
        "price_not_uom_dependent"
    ],
    "ItemPrice": [
        "item_code",
        "uom",
        "packing_unit",
        "item_name",
        "Item Description",
        "brand",
        "price_list",
        "buying",
        "selling",
        "currency",
        "price_list_rate",
        "valid_from",
        "valid_upto",
        "Note"
    ],
    "Item": [
        "item_code",
        "item_name",
        "item_group",
        "stock_uom",
        "disabled",
        "is_stock_item",
        "image",
        "description",
        "brand",
        "warranty_period",
        "weight_per_unit",
        "weight_uom",
        "valuation_rate",
        "standard_rate",
        "item_type",
        "end_of_life",
        "shelf_life_in_days",
        "has_batch_no",
        "has_serial_no",
        "batch_number_series",
        "has_expiry_date",
        "purchase_uom",
        "min_order_qty",
        "safety_stock",
        "is_purchase_item",
        "last_purchase_rate",
        "sales_uom",
        "is_sales_item",
        "max_discount"
    ],
    "Addon": [
        "item_code",
        "item_name",
        "item_group",
        "stock_uom",
        "disabled",
        "is_stock_item",
        "image",
        "description",
        "brand",
        "warranty_period",
        "weight_per_unit",
        "weight_uom",
        "valuation_rate",
        "standard_rate",
        "item_type",
        "end_of_life",
        "shelf_life_in_days",
        "has_batch_no",
        "has_serial_no",
        "batch_number_series",
        "has_expiry_date",
        "purchase_uom",
        "min_order_qty",
        "safety_stock",
        "is_purchase_item",
        "last_purchase_rate",
        "sales_uom",
        "is_sales_item",
        "max_discount"
    ],
    "POSProfile": [
        "name",
        "warehouse"
    ],
    "POSInvoice": [
        "title",
        "naming_series",
        "customer",
        "tax_id",
        "pos_profile",
        "is_return",
        "posting_date",
        "posting_time",
    ],
    // get_items method call.
    "TableOrderGetItem": [
        "identifier",
        "item_group",
        "item_code",
        "item_name",
        "image",
        "qty",
        "rate",
        "amount",
        "discount_percentage",
        "discount_amount",
        "price_list_rate",
        "item_tax_template",
        "item_tax_rate",
        "table_description",
        "status",
        "notes",
        "ordered_time",
        "has_batch_no",
        "batch_no",
        "has_serial_no",
        "serial_no",
        "order_name",
        "entry_name",
        "short_name",
        "process_status_data", // Please see below.
    ],
    "process_status_data" : [
        "next_action_message",
        "color",
        "icon",
        "status_message",
    ],




};

export default docTypeFields
